export type { FC } from "react";

export interface Props {
  name: string;
  className?: string;
  circleClassName?: string;
  status?: EStatus;
  avatar?: string;
  size?: "normal" | "small" | "large";
}

export enum EStatus {
  ONLINE = "ONLINE",
  OFFLINE = "OFFLINE",
}
